import React, { useContext } from "react";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { illustration, greeting } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const { isDark } = useContext(StyleContext);

  if (!greeting.displayGreeting) {
    return null;
  }

  return (
    <div className="greet-main" id="greeting">
      <div className="greeting-main">
        <div className="greeting-text-div">
          <div>
            <h1 className={isDark ? "dark-mode greeting-text" : "greeting-text"}>
              {greeting.title}
              <span className="wave-emoji"></span>
            </h1>

            <p className={isDark ? "dark-mode greeting-text-p" : "greeting-text-p subTitle"}>
              {greeting.subTitle}
            </p>

            <div id="resume" className="empty-div"></div>
            <SocialMedia />

            <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
              {greeting.resumeLink && (
                <a
                  href={require("./sheikhwasimuddin_resume.pdf")}
                  download="Resume.pdf"
                  className="download-link-button"
                >
                  <Button text="Resume" />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="greeting-image-div">
          {illustration.animated ? (
            <DisplayLottie animationData={landingPerson} />
          ) : (
            <img
              alt="man sitting on table"
              src={require("../../assets/images/manOnTable.svg")}
            />
          )}
        </div>
      </div>
    </div>
  );
}